import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: ISlices.IUserInitialState = {
  userInfo: null,
  userLoading: false,
  paymentModal: false,
  paymentConfirmed: false,
  documentModal: false,
  documentConfirmed: false,
  creditModal: false,
  creditConfirmed: false,
  cardModal: false,
  cardConfirmed: false,
};

export const userInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setUserInfo(state: any, action: PayloadAction<IUtils.IGetUserData>) {
      state.userInfo = action.payload;
    },
    setUserLoading(
      state: { userLoading: boolean },
      action: PayloadAction<boolean>
    ) {
      state.userLoading = action.payload;
    },
    setPaymentModal(
      state: { paymentModal: boolean },
      action: PayloadAction<boolean>
    ) {
      state.paymentModal = action.payload;
    },
    setPaymentConfirmed(
      state: { paymentConfirmed: boolean },
      action: PayloadAction<boolean>
    ) {
      state.paymentConfirmed = action.payload;
    },
    setDocumentModal(
      state: { documentModal: boolean },
      action: PayloadAction<boolean>
    ) {
      state.documentModal = action.payload;
    },
    setDocumentConfirmed(
      state: { documentConfirmed: boolean },
      action: PayloadAction<boolean>
    ) {
      state.documentConfirmed = action.payload;
    },

    setCreditModal(
      state: { creditModal: boolean },
      action: PayloadAction<boolean>
    ) {
      state.creditModal = action.payload;
    },
    setCreditConfirmed(
      state: { creditConfirmed: boolean },
      action: PayloadAction<boolean>
    ) {
      state.creditConfirmed = action.payload;
    },

    setCardModal(
      state: { cardModal: boolean },
      action: PayloadAction<boolean>
    ) {
      state.cardModal = action.payload;
    },
    setCardConfirmed(
      state: { cardConfirmed: boolean },
      action: PayloadAction<boolean>
    ) {
      state.cardConfirmed = action.payload;
    },
  },
});

export const {
  setUserInfo,
  setUserLoading,
  setPaymentModal,
  setPaymentConfirmed,
  setDocumentModal,
  setDocumentConfirmed,
  setCreditModal,
  setCreditConfirmed,
  setCardModal,
  setCardConfirmed,
} = userInfoSlice.actions;
export default userInfoSlice.reducer;
